import { render, staticRenderFns } from "./FormEvidencia.vue?vue&type=template&id=1a4d0678&"
import script from "./FormEvidencia.vue?vue&type=script&lang=js&"
export * from "./FormEvidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports